//Firebase urls
export const FIREBASE_BASE_URL = "https://foodbookpwa.firebaseio.com";
export const FIREBASE_FAQS = FIREBASE_BASE_URL + "/FAQs.json";
export const FIREBASE_STATIC_DATA = FIREBASE_BASE_URL + "/.json";

export const EXCLUDE_URLS = [FIREBASE_FAQS, FIREBASE_STATIC_DATA];
export const SWAGGER_EXCLUDE_URL = "/v2/app";

const demoFirebaseConfig = {
  apiKey: "AIzaSyBAlukNz5FAtbQUqD4A49KFJC_78hzNCu8",
  authDomain: "smartqdemo.firebaseapp.com",
  databaseURL: "https://smartqdemo.firebaseio.com",
  projectId: "smartqdemo",
  storageBucket: "smartqdemo.appspot.com",
  messagingSenderId: "305419562445",
  appId: "1:305419562445:web:98fd4d03d5e40733266884"
};

// Old prod settings
// const prodFirebaseConfig = {
// apiKey: "AIzaSyCkXoQNaR4ZeTcqtlod1Ua-gF17cqjfNnU",
// authDomain: "smartq-prd-11c9d.firebaseapp.com",
// databaseURL: "https://smartq-prd-11c9d.firebaseio.com",
// projectId: "smartq-prd-11c9d",
// storageBucket: "smartq-prd-11c9d.appspot.com",
// messagingSenderId: "19332199132"
// };

// New prod settings
const prodUSFirebaseConfig = {
  apiKey: "AIzaSyBHDUHi5zouLj2peqG3Ul0_G1J3ADO-ZfE",
  authDomain: "smartq-prd.firebaseapp.com",
  databaseURL: "https://smartq-prd.firebaseio.com",
  projectId: "smartq-prd",
  storageBucket: "smartq-prd.appspot.com",
  messagingSenderId: "176856380815",
  appId: "1:176856380815:web:27564a7e545233c6"
};

// New India prod settings
const prodIndiaFirebaseConfig = {
  apiKey: "AIzaSyBWb1xBNO775OeyAh7WXo59xi20Pz7wNEU",
  authDomain: "smartqprd-india.firebaseapp.com",
  databaseURL: "https://smartqprd-india.firebaseio.com",
  projectId: "smartqprd-india",
  storageBucket: "smartqprd-india.appspot.com",
  messagingSenderId: "899123343629",
  appId: "1:899123343629:web:2a657a6a2aca221199c044"
};

const devSettings = {
  // BASE_URL: "https://lwfeedback-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://sqoffice-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://amazonpay2-dot-foodbook-dot-smartqdemo.appspot.com",
  BASE_URL: "",
  // BASE_URL: "https://nvidialogin-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://globalsearch-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://slotorder-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://demo.foodbook.co.in",
  // BASE_URL: "https://ordercancel-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://multirestaurant-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://zetapay-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://multiorders-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://profilepic-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://shellorders-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://zetapay-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://multiorders-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL:
  //   "https://orderhistorychanges-dot-foodbook-dot-smartqdemo.appspot.com",
  // BASE_URL: "https://prodrelease-dot-foodbook-dot-smartq-prd.appspot.com",
  // BASE_URL: "https://ctrldesk-dot-foodbook-dot-smartqdemo.appspot.com",
  // SWAGGER_BASE_URL: "https://smartqdemo.thesmartq.com/v2/app",
  SWAGGER_BASE_URL: "/v2/app",
  ORDERID_BEGINNER: "DDFB",
  RECHARGEID_BEGINNER: "RDDFB",
  SODEXOID_BEGINNER: "DDFBSOD",
  FIREBASE_DATABASE: demoFirebaseConfig,
  FIREBASE_NOTIFICATION: demoFirebaseConfig,
  MENU_IMAGE_BASE_URL: "https://storage.googleapis.com/smartqdemo",
  TINY_FEEDBACK_URL: "https://tinyurl.com/r7bkdy7"
};

const demoSettings = {
  BASE_URL: "..",
  ORDERID_BEGINNER: "DFB",
  RECHARGEID_BEGINNER: "RDFB",
  SODEXOID_BEGINNER: "DFBSOD",
  FIREBASE_DATABASE: demoFirebaseConfig,
  FIREBASE_NOTIFICATION: demoFirebaseConfig,
  MENU_IMAGE_BASE_URL: "https://storage.googleapis.com/smartqdemo",
  TINY_FEEDBACK_URL: "https://tinyurl.com/r7bkdy7",
  SWAGGER_BASE_URL: "../v2/app"
};

const prodSettings = {
  BASE_URL: "..",
  ORDERID_BEGINNER: "FB",
  RECHARGEID_BEGINNER: "RFB",
  SODEXOID_BEGINNER: "FBSOD",
  FIREBASE_DATABASE: prodIndiaFirebaseConfig,
  FIREBASE_NOTIFICATION: prodUSFirebaseConfig,
  MENU_IMAGE_BASE_URL: "https://storage.googleapis.com/smartq-prd",
  TINY_FEEDBACK_URL: "https://tinyurl.com/yfaf5x4s",
  SWAGGER_BASE_URL: "../v2/app"
};

const prodSettingsFBCafe = {
  BASE_URL: "..",
  ORDERID_BEGINNER: "FBC",
  RECHARGEID_BEGINNER: "RFBC",
  SODEXOID_BEGINNER: "FBCSOD",
  FIREBASE_DATABASE: prodIndiaFirebaseConfig,
  FIREBASE_NOTIFICATION: prodUSFirebaseConfig,
  MENU_IMAGE_BASE_URL: "https://storage.googleapis.com/smartq-prd",
  TINY_FEEDBACK_URL: "https://tinyurl.com/yfaf5x4s",
  SWAGGER_BASE_URL: "../v2/app"
};

const domainName = window.location.hostname;
let settings = {};
if (domainName.includes("localhost")) {
  settings = devSettings;
} else if (domainName.includes("demo")) {
  settings = demoSettings;
} else if (domainName.includes("foodbookcafe")) {
  settings = prodSettingsFBCafe;
} else {
  settings = prodSettings;
}

export const BASE_URL = settings.BASE_URL;
export const SWAGGER_BASE_URL = settings.SWAGGER_BASE_URL;
export const ORDERID_BEGINNER = settings.ORDERID_BEGINNER;
export const RECHARGEID_BEGINNER = settings.RECHARGEID_BEGINNER;
export const SODEXOID_BEGINNER = settings.SODEXOID_BEGINNER;
export const FIREBASE_DATABASE = settings.FIREBASE_DATABASE;
export const FIREBASE_NOTIFICATION = settings.FIREBASE_NOTIFICATION;
export const STORAGE_BASE_URL = "https://storage.googleapis.com/smartqdemo";
export const GOOGLE_STORAGE_URL = "https://storage.googleapis.com";
export const PROFILE_PIC_STORAGE_URL = "https://storage.googleapis.com";
export const TINY_FEEDBACK_URL = settings.TINY_FEEDBACK_URL;
export const BASE_NAME = "foodbook-pwa";
// export const BASE_NAME = "";
export const DEFAULT_FOOD_INFO_LINK = "";
// export const DEFAULT_FOOD_INFO_LINK =
//   STORAGE_BASE_URL + "/foodbook-allergents/allergents6.html";

export const FOODCOURT_MENU_SEARCH = "/foodcourtmenu";
export const FOODBOOK_URL = "/foodbook";
export const FOOD_IMAGE_URL = "food_images/";
export const REST_IMAGE_URL = "logos/";
export const IMAGE_BASE_URL = settings.MENU_IMAGE_BASE_URL + "/images/";
export const DEFAULT_NOT_FOUND =
  STORAGE_BASE_URL + "/foodbook-allergents/notFound1.html";

//API EndPoints
export const GET_FOOD_COURTS = FOODBOOK_URL + "/getfoodcourts";
export const GET_USER_FOOD_COURTS = FOODBOOK_URL + "/userfoodcourtaccess";
export const GET_FOOD_COURT_SETTINGS = FOODBOOK_URL + "/foodcourtsettings";
export const SIGNUP = FOODBOOK_URL + "/signup";
export const SIGNIN = FOODBOOK_URL + "/login";
export const VERIFY_OTP = FOODBOOK_URL + "/verifyotp";
export const RESEND_OTP_SIGNUP = FOODBOOK_URL + "/resendotp";
export const SEND_OTP_FORGOT_PASSWORD = FOODBOOK_URL + "/sendotp";
export const UPDATE_PASSWORD = FOODBOOK_URL + "/updatepassword";
export const CHECK_AUTHENTICATION = FOODBOOK_URL + "/auth";
export const LOGOUT = FOODBOOK_URL + "/logout";
export const RESET_PASSWORD = FOODBOOK_URL + "/resetpassword";
export const UPDATE_PROFILE = FOODBOOK_URL + "/updateprofile";
export const GET_PROFILE = FOODBOOK_URL + "/profile";
export const SEND_FEEDBACK = FOODBOOK_URL + "/support";
export const GET_SUPPORT_TEMPLATE = FOODBOOK_URL + "/supporttemplate";
export const FEEDBACKTEMPLATE = FOODBOOK_URL + "/feedbacktemplate";
export const POST_ORDER_FEEDBACK = FOODBOOK_URL + "/postorderfeedback";
export const GET_FAVORITES = FOODBOOK_URL + "/favourites";
export const GET_LIKES = FOODBOOK_URL + "/likes";
export const GET_LIST_LOCATION = "/listlocation";
export const GET_MENU = "/getmenu";
export const GENERIC_FEEDBACK = "/generic_app_controller";
export const SLOT_CANCEL = "/slots/cancel";
// export const PLACE_ORDER = "/placeorder"; // old API
export const PLACE_ORDER = "/placemultipleorders";
export const ORDER_HISTORY = FOODBOOK_URL + "/orderhistory";
// export const CHECK_ORDER_STATUS = "/checkandpushorder"; // old API
export const CHECK_ORDER_STATUS = "/checkandpushmultipleorders";
export const UPDATE_PUSH_ID = "/updatepushid";
export const OUT_OF_STOCK = "/v1/restaurant/outOfStock";
export const GET_TRANSACTION = "/sqtxnapi";
export const ONLINE_RECHARGE = "/onlinerecharge";
export const CHECK_RECHARGE_STATUS = "/checkonlinerecharge";
export const CHANGE_MOBILE_OR_EMAIL = FOODBOOK_URL + "/resendotp";
// export const DOWNLOAD_INVOICE = "/getpdfinvoice?orderid=";
export const ORDER_INVOICE = "/getpdfinvoice";
export const GET_ECASH = FOODBOOK_URL + "/getecash";
export const RATING = "/ratemenuitem";
export const USER_PREFERENCE = "/userpreference";
export const CONTACT_US = FOODBOOK_URL + "/contactus";
export const TERMS_AND_CONDITIONS = FOODBOOK_URL + "/termsandcondition";
export const LINK_SODEXO_CARD = "/linksodexocard";
export const DELINK_SODEXO_CARD = "/delinksodexocard";
export const GET_SODEXO_BALANCE = "/getsodexobalance";
export const CHECK_SODEXO_TXN_STATUS = "/checksodexotxnstatus";
export const CANCEL_PREORDER_URL = "/foodbook/ordercancel";
// foodiepedia and recipe
export const GET_HTML_PAGE = "/gethtmlpage";

// new swagger urls
export const BOOK_SLOT_URL = SWAGGER_BASE_URL + "/slots/book";
export const LIST_SLOTS_URL = SWAGGER_BASE_URL + "/slots/list?foodcourt=";



// WEBPACK FOOTER //
// ./src/utils/Urls.js